/**
 * Control Tributario API Service
 * Libro de Compras/Ventas, Retenciones, Resumen IVA
 */
import api from './api';

const API_BASE_URL = (() => {
  const baseURL = api?.defaults?.baseURL || '/api/content';
  return baseURL.replace(/\/content\/?$/i, '/contabilidad');
})();

const tributarioService = {
  // ============================================
  // Libro de Compras y Ventas
  // ============================================
  libros: {
    getAll: (filters = {}) => api.get(`${API_BASE_URL}/libros-compra-venta/`, { params: filters }),
    getById: (id) => api.get(`${API_BASE_URL}/libros-compra-venta/${id}/`),
    create: (data) => api.post(`${API_BASE_URL}/libros-compra-venta/`, data),
    generar: (id) => api.post(`${API_BASE_URL}/libros-compra-venta/${id}/generar/`),
    cerrar: (id) => api.post(`${API_BASE_URL}/libros-compra-venta/${id}/cerrar/`),
  },

  // ============================================
  // Retenciones
  // ============================================
  retenciones: {
    getAll: (filters = {}) => api.get(`${API_BASE_URL}/retenciones/`, { params: filters }),
    getById: (id) => api.get(`${API_BASE_URL}/retenciones/${id}/`),
    create: (data) => api.post(`${API_BASE_URL}/retenciones/`, data),
    update: (id, data) => api.patch(`${API_BASE_URL}/retenciones/${id}/`, data),
    delete: (id) => api.delete(`${API_BASE_URL}/retenciones/${id}/`),
  },

  // ============================================
  // Resumen IVA
  // ============================================
  resumenIVA: {
    getAll: (filters = {}) => api.get(`${API_BASE_URL}/resumenes-iva/`, { params: filters }),
    getById: (id) => api.get(`${API_BASE_URL}/resumenes-iva/${id}/`),
    create: (data) => api.post(`${API_BASE_URL}/resumenes-iva/`, data),
    calcular: (id) => api.post(`${API_BASE_URL}/resumenes-iva/${id}/calcular/`),
  },
};

export default tributarioService;
